var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5368 0.357954C10.8715 0.0232193 11.4142 0.0232193 11.7489 0.357954C12.0837 0.69269 12.0837 1.2354 11.7489 1.57014L7.21218 6.1069L11.7489 10.6437C12.0837 10.9784 12.0837 11.5211 11.7489 11.8559C11.4142 12.1906 10.8715 12.1906 10.5368 11.8559L6 7.31909L1.46323 11.8559C1.1285 12.1906 0.585786 12.1906 0.251052 11.8559C-0.0836839 11.5211 -0.0836839 10.9784 0.251052 10.6437L4.78782 6.1069L0.251052 1.57014C-0.0836834 1.2354 -0.0836834 0.69269 0.251052 0.357954C0.585787 0.0232193 1.1285 0.0232193 1.46323 0.357954L6 4.89472L10.5368 0.357954Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.7eb37d08e4d9f015212f51fa60bd4e40.svg";
export { ForwardRef as ReactComponent };